import { Box } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import useColors from "../api/hooks/useColors";

export default function Datepicker({
  value,
  onChange,
  label = "Select Date",
  format = "MM/DD/YYYY",
  disableFuture = false,
  minWidth = "120px",
  ...props
}) {
  const colors = useColors();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <Box minWidth={minWidth}>
        <DatePicker
          disableFuture={disableFuture}
          label={value ? "" : label}
          value={value}
          onChange={onChange}
          format={format}
          slotProps={{
            textField: {
              size: "small",
              placeholder: value ? "" : label,
              sx: {
                height: "32px",
                "& .MuiOutlinedInput-root": {
                  height: "32px",
                  borderRadius: "8px",
                  border: `1px solid ${colors.divider2}`,
                  backgroundColor: colors.grey_50,
                  fontSize: "12px",
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
                "& .MuiInputBase-input": {
                  height: "32px",
                  padding: "0 8px",
                  fontSize: "12px",
                  color: colors.contrast_text_dark,
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  "&::placeholder": {
                    color: colors.contrast_text_dark,
                    opacity: 1,
                    fontSize: "12px",
                  },
                },
                "& .MuiInputLabel-root": {
                  fontSize: "12px",
                  color: colors.contrast_text_dark,
                  transform: "translate(8px, 8px) scale(1)",
                  "&.Mui-focused, &.MuiFormLabel-filled": {
                    transform: "translate(8px, -6px) scale(0.75)",
                  },
                  display: value ? "none" : "block",
                },
                "& .MuiInputAdornment-root": {
                  "& .MuiIconButton-root": {
                    padding: "4px",
                    color: colors.contrast_text_dark,
                  },
                },
              },
            },
          }}
          {...props}
        />
      </Box>
    </LocalizationProvider>
  );
}
